module.exports = __webpack_public_path__ + "static/media/bandeiras_cartao.ab420ba6.svg";